import { render, staticRenderFns } from "./change-password-container.vue?vue&type=template&id=37b62184&scoped=true&lang=pug"
import script from "./change-password-container.js?vue&type=script&lang=js&external"
export * from "./change-password-container.js?vue&type=script&lang=js&external"
import style0 from "./change-password-container.vue?vue&type=style&index=0&id=37b62184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b62184",
  null
  
)

export default component.exports